package ru.education.building.schedule.data.datasources

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import ru.education.building.schedule.data.models.ApiResponse
import ru.education.building.schedule.data.models.ApiResponseGroup
import ru.education.building.schedule.data.models.Misis
import ru.education.building.schedule.data.models.MisisGroups

class ApiService(private val client: HttpClient) {
    suspend fun getSchedule(id: String): List<Misis> {
        val resp = client.get("https://app-education.ru/api/parse/v3/getSchedule/$id").body<ApiResponse>()
        val item: List<Misis> = resp.data

        return item
    }

    suspend fun getGroup(): List<MisisGroups> {
        val resp = client.get("https://app-education.ru/api/parse/v2/getGroups").body<ApiResponseGroup>()
        val item: List<MisisGroups> = resp.data

        return item
    }
}